var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.organizationForDocument.name)?_c('span',{staticClass:"caption font-weight-bold"},[_vm._v("\n  "+_vm._s(_vm.organizationForDocument.name)+" ("+_vm._s(_vm.organizationForDocument.businessId)+")\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }